// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-promo-code-rules a{color:#0c0243}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"promo-code-rules": "bw-promo-code-rules"
};
module.exports = ___CSS_LOADER_EXPORT___;
